export const skills = {
  react: {
    name: "React JS",
    url: "/assets/skills/react.svg",
  },
  angular: { name: "Angular", url: "/assets/skills/angular.svg" },
  next: { name: "Next JS", url: "/assets/skills/next-js.svg" },
  html: { name: "HTML 5", url: "/assets/skills/html5.svg" },
  css: { name: "CSS 3", url: "/assets/skills/css-3.svg" },
  bootstrap: { name: "Bootstrap", url: "/assets/skills/bootstrap.svg" },
  materialUI: { name: "Material UI", url: "/assets/skills/material-ui.svg" },
  tailwind: { name: "Tailwind CSS", url: "/assets/skills/tailwind-css.svg" },
  node: { name: "Node JS", url: "/assets/skills/nodejs.svg" },
  express: { name: "Express JS", url: "/assets/skills/express.svg" },
  nest: { name: "Nest JS", url: "/assets/skills/nest.svg" },
  shopify: { name: "Shopify Apps", url: "/assets/skills/shopify.svg" },
  mongo: { name: "MongoDB", url: "/assets/skills/mongodb.svg" },
  postgres: { name: "PostgreSQL", url: "/assets/skills/postgresql.svg" },
  mysql: { name: "MySQL", url: "/assets/skills/mysql.svg" },
  graphql: { name: "GraphQL", url: "/assets/skills/graphql.svg" },
  firebase: { name: "Firebase", url: "/assets/skills/firebase.svg" },
  elasticSearch: {
    name: "Elastic Search",
    url: "/assets/skills/elasticsearch.svg",
  },
  ec2: { name: "AWS EC2", url: "/assets/skills/aws-ec2.svg" },
  lambda: { name: "AWS Lambda", url: "/assets/skills/aws-lambda.svg" },
  cloudwatch: {
    name: "AWS Cloudwatch",
    url: "/assets/skills/aws-cloudwatch.svg",
  },
  route53: { name: "AWS Route53", url: "/assets/skills/aws-route53.svg" },
  elasticBeanstalk: {
    name: "AWS Elastic Beanstalk",
    url: "/assets/skills/aws-elastic-beanstalk.svg",
  },
  xState: {
    name: "X State",
    url: "/assets/skills/x-state.ico",
  },
  redis: {
    name: "Redis",
    url: "/assets/skills/redis.svg",
  },
  socket: {
    name: "Socket IO",
    url: "/assets/skills/socket-io.svg",
  },
  spring: {
    name: "Spring",
    url: "/assets/skills/spring.svg",
  },
  threejs: {
    name: "Three JS",
    url: "/assets/skills/threejs.svg",
  },
  pactTests: {
    name: "Pact Testing",
    url: "/assets/skills/pact.png",
  },
  cypress: {
    name: "Cypress Testing",
    url: "/assets/skills/cypress.png",
  },
  jest: {
    name: "Jest",
    url: "/assets/skills/jest.svg",
  },
  typescript: {
    name: "Typescript",
    url: "/assets/skills/typescript.svg",
  },
  redux: {
    name: "Redux",
    url: "/assets/skills/redux.svg",
  },
  reduxSaga: {
    name: "Redux Saga",
    url: "/assets/skills/redux-saga.svg",
  },
  kafka: {
    name: "Kafka",
    url: "/assets/skills/kafka.svg",
  },
  python: {
    name: "Python",
    url: "/assets/skills/python.svg",
  },
  aws: {
    name: "AWS",
    url: "/assets/skills/aws.svg",
  },
  docker: {
    name: "Docker",
    url: "/assets/skills/docker.svg",
  },
  gcp: {
    name: "GCP",
    url: "/assets/skills/gcp.svg",
  },
  kubernetes: {
    name: "Kubernetes",
    url: "/assets/skills/kubernetes.svg",
  },
  githubActions: {
    name: "GitHub Actions",
    url: "/assets/skills/github.svg",
  },
  dbt: {
    name: "Data Build Tool",
    url: "/assets/skills/dbt.ico",
  },
  snowflake: {
    name: "Snowflake",
    url: "/assets/skills/snowflake.svg",
  },
  mastraAI: {
    name: "Mastra AI",
    url: "/assets/skills/mastra-ai.svg",
  },
};

// ─── SKILL CATEGORIES (icon grid on the About page + AI agent) ─────────────────
// Grouped references into the registry above. The About page renders the icons;
// the AI agent (src/index.ts) reads each entry's `.name`.
export const skillCategories = [
  {
    stack: "Front End Technologies",
    skills: [
      skills.react,
      skills.next,
      skills.typescript,
      skills.angular,
      skills.redux,
      skills.reduxSaga,
      skills.html,
      skills.css,
      skills.bootstrap,
      skills.tailwind,
      skills.materialUI,
    ],
  },
  {
    stack: "Back End Technologies",
    skills: [
      skills.nest,
      skills.node,
      skills.express,
      skills.mastraAI,
      skills.python,
      skills.kafka,
      skills.snowflake,
      skills.dbt,
    ],
  },
  {
    stack: "Testing",
    skills: [skills.jest, skills.cypress, skills.pactTests],
  },
  {
    stack: "Databases",
    skills: [skills.mongo, skills.postgres, skills.mysql, skills.graphql],
  },
  {
    stack: "Cloud Services",
    skills: [
      skills.aws,
      skills.gcp,
      skills.docker,
      skills.kubernetes,
      skills.githubActions,
      skills.firebase,
      skills.elasticSearch,
    ],
  },
];

// ─── RÉSUMÉ SKILL GROUPS ──────────────────────────────────────────────────────
// Named groups (plain strings, including concepts with no icon) composed into the
// three résumé flavours below so each shared group is defined exactly once.
const skillGroups = {
  frontend: {
    type: "Frontend",
    skills: [
      "React.js",
      "Next.js",
      "TypeScript",
      "Angular",
      "Redux",
      "Tailwind CSS",
      "Chakra UI",
      "Material UI",
      "Progressive Web App",
      "Responsive Design",
    ],
  },
  backend: {
    type: "Backend",
    skills: [
      "Node.js",
      "Nest.js",
      "Express.js",
      "TypeScript",
      "REST APIs",
      "Microservices",
      "GraphQL",
      "Redis",
      "PostgreSQL",
      "MongoDB",
      "Snowflake",
    ],
  },
  aiLlm: {
    type: "AI & LLM",
    skills: [
      "LLM Integration",
      "Generative AI",
      "AI Agent Development",
      "Prompt Engineering",
      "OpenAI API",
      "Mastra AI",
    ],
  },
  testingFull: {
    type: "Testing",
    skills: ["Jest", "Supertest", "Cypress", "Pact Tests", "Unit Testing", "E2E Testing"],
  },
  testingFrontend: {
    type: "Testing",
    skills: ["Jest", "Cypress", "Unit Testing", "E2E Testing", "Storybook"],
  },
  testingBackend: {
    type: "Testing",
    skills: ["Jest", "Supertest", "Pact Tests", "Unit Testing", "Integration Testing"],
  },
  cloudFull: {
    type: "Cloud and Infrastructure",
    skills: ["Docker", "Kubernetes", "CI/CD", "AWS", "GCP", "Azure", "GitHub Actions"],
  },
  cloudFrontend: {
    type: "Cloud and Infrastructure",
    skills: ["Docker", "AWS", "GCP", "CI/CD", "GitHub Actions"],
  },
};

export const resumeSkills = [
  skillGroups.frontend,
  skillGroups.backend,
  skillGroups.aiLlm,
  skillGroups.testingFull,
  skillGroups.cloudFull,
];

export const frontendResumeSkills = [
  skillGroups.frontend,
  skillGroups.testingFrontend,
  skillGroups.cloudFrontend,
];

export const backendResumeSkills = [
  skillGroups.backend,
  skillGroups.aiLlm,
  skillGroups.testingBackend,
  skillGroups.cloudFull,
];
